import { Options } from '@angular-slider/ngx-slider';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AllStaticText, TypeList } from '../add-company/add-company.model';
import { NgbActiveModal, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { LabelsName, RoutePath, TabNames } from '../../../../../shared/model/enum';
import { ToastrService } from 'ngx-toastr';
import { CrmService } from '../../../crm.service';
import { CommonTabService } from '../../../../../shared/services/common-tab.service';
import { state } from "@angular/animations";

import {
  CommonFilterModel,
  CompanyFilterList,
  FilterCheckList,
  GetAllDropDownModel,
} from "../../pages/companies/companies.model";
import { StorageService } from "../../../../../shared/services/storage.service";
import { TabsService } from '../../../../../shared/components/tabs/tabs.service';
import { UserSetting } from '../../../crm.model';
import { SaveUserSetting } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { AgGridService } from '../../../../../shared/components/ag-grid/ag-grid.service';
import { Router } from '@angular/router';
import { StingToDateService } from '../../../../../shared/services/stringToDate.service';
import { WindowSizeService } from '../../../../../shared/services/window-resize.service';
import { PartsListService } from '../../../../parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { Categories } from '../../../../../shared/model/enum';

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit {
  @Input() stagesName: string;
  @Input() getAllDropDownModel = new GetAllDropDownModel();

  @Input() vendorPartLibraryFilters: boolean = false;
  @Input() requirementFilters: boolean = false;

  
  saleStageList: TypeList[] = [];
  enumFilterLabel = LabelsName;
  filterCheckList = new FilterCheckList();
  tagsList: CommonFilterModel[] = [];
  partTagsList : CommonFilterModel[] = [];
  requirementStatusList : CommonFilterModel[] = [];
  opportunityTypeList : CommonFilterModel[] = [];
  priorityList : CommonFilterModel[]=[];
  opportunityBuyTypeList : CommonFilterModel[]=[];
  classList: CommonFilterModel[] = [];
  vendorTypeList: CommonFilterModel[] = [];
  filterPopupVM = new AllStaticText;
  isSuccess: boolean = false;
  showMore: boolean = true;
  companyFiltersList = new CompanyFilterList();
  currentTab = ''
  saleStagedata: any
  userSetting = new UserSetting();
  saveUserSetting = new SaveUserSetting();
  activeList = [
    { id: 1, name: "Active", labelName: "Active", isActive: false },
    { id: 0, name: "Inactive", labelName: "InActive", isActive: false },
  ];
  enumTabNames            = TabNames;
  //#region ngx slider region start
  options: Options = {
    floor: 0.0,
    ceil: 5.0,
    step: 0.5,
    showSelectionBar: true,
  };

  probabilityOptions : Options = {
    floor: 0,
    ceil: 100,
    step: 1,
    showSelectionBar: true,
  }
  contactedDate:any;
  dateRangeSelection:any | null;
  //#endregion ngx slider region start
route;
width: number  = 768;

list = [{id:'1',name:'name'},{id:'2',name:'name2'},{id:'3',name:'name3'}]
data:any ={}
isLargeScreen = window.innerWidth > 1024;
routerPath = RoutePath
  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public crmService: CrmService,
    public commonTabService: CommonTabService,
    public storage: StorageService,
    public tabsService: TabsService,
    public agGridService: AgGridService,
    private router: Router,
    public stringToDateService: StingToDateService,
    private windowSizeService: WindowSizeService,
    public partsListService: PartsListService,
    public formatter: NgbDateParserFormatter
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isLargeScreen = event.target.innerWidth > 1024;
  }
  ngOnInit(): void {
    this.windowSizeService.getScreenWidth().subscribe((res) => {
      this.width = res;
    }); 

    this.route = this.router.url
    // this.fillCheckedList();
    this.tabsService.currentTab.subscribe(res => {
      if (res) {
        this.currentTab = res;
      } else {
        this.currentTab = this.tabsService.thisTab
      }
    })
    this.saleStagedata = (this.stagesName == '2' ? 'Lead' : (this.stagesName == '3' ? 'Prospect' : this.stagesName));
    console.log("saleStagedata",this.saleStagedata);
    
    // this.saleStagedata = this.stagesName
    this.tagsList = this.getAllDropDownModel?.tagsList;
    this.partTagsList = this.getAllDropDownModel?.partTagsList;
    this.requirementStatusList = this.getAllDropDownModel?.requirementStatusList;
    this.opportunityTypeList = this.getAllDropDownModel?.opportunityTypeList;
    this.priorityList = this.getAllDropDownModel?.priorityList;
    this.opportunityBuyTypeList = this.getAllDropDownModel?.opportunityBuyTypeList;

    this.classList = this.getAllDropDownModel?.classList;
    this.vendorTypeList = this.getAllDropDownModel?.vendorTypeList;
    this.activeList
      ?.filter((a) => a.id === this.getAllDropDownModel?.companyStatusId)
      ?.map((a) => (a.isActive = true));
    this.fillCheckedList();
    if (this.contactedDate) {
      this.contactedDate = this.stringToDateService?.convertStringToDate(this.contactedDate)
    } else if(this.getAllDropDownModel?.fromDate){
      this.contactedDate  = this.stringToDateService.convertStringToDate(this.getAllDropDownModel?.fromDate)
    }
    // else {
    //   this.contactedDate = this.convertStringToDate(this.filterCheckList.last_Contacted_CheckList)
      
    // }

    // if (this.contactedDate) {
    //   this.contactedDate = this.stringToDateService.convertStringToDate(this.contactedDate)
    // } else if(this.getAllDropDownModel?.fromDate){
    //   this.contactedDate  = this.stringToDateService.convertStringToDate(this.getAllDropDownModel?.fromDate)
    // }

  }


  fillCheckedList() {
    // check list from storage
    let checked
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      checked = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.LEADS ) {
      checked = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS );
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      checked = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      checked = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      checked = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      checked = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS)
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      checked = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS

      );
    }
    if (this.currentTab == this.enumTabNames.PARTLIST) {
      checked = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      checked = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      checked = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS);
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      checked = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS);
    }

    let drops = checked?.allDropDowns;
    // updating the dropdown from local storage
    if (drops?.endRating) {
      this.getAllDropDownModel.endRating = drops?.endRating
      this.getAllDropDownModel.startRating = drops?.startRating
    }
   if(drops?.fromDate){
    this.getAllDropDownModel.fromDate = drops?.fromDate
   }
    if(drops?.toDate){
    this.getAllDropDownModel.toDate = drops?.toDate
   }

    if(drops?.fromDate && drops?.toDate){
     this.dateRangeSelection = `${drops.fromDate} - ${drops.toDate}`;
   }else{
   if(drops?.fromDate){
    this.contactedDate = this.stringToDateService.convertStringToDate(drops?.fromDate)
   }
   }
    this.tagsList?.map(value => {
      drops?.tagsList?.map(tl => {
        if (tl.id == value.id) {
          value.isActive = tl.isActive
        }
      })
    })
    if (drops?.archived) {
      this.getAllDropDownModel.archived = drops?.archived
    }
    if (drops?.avl == true) {
      this.getAllDropDownModel.avl = true
      this.getAllDropDownModel.avlId = 1
    }
    if (drops?.navl == true) {
      this.getAllDropDownModel.navl = true
      this.getAllDropDownModel.avlId = 2
    }
    if(drops?.navl == true && drops?.avl == true){
      this.getAllDropDownModel.navl = true;
      this.getAllDropDownModel.avl = true
      this.getAllDropDownModel.avlId = 3

    } 
    if(drops?.navl == false && drops?.avl == false){
      this.getAllDropDownModel.navl = false;
      this.getAllDropDownModel.avl = false
      this.getAllDropDownModel.avlId = 0
    }

    // if (drops?.avlId == 2 && (drops?.avl && drops?.navl)) {
    //   this.getAllDropDownModel.avl = true
    //   this.getAllDropDownModel.navl = true
    // }

    if (drops?.excludedFromVendorlist) {
      this.getAllDropDownModel.excludedFromVendorlist = drops?.excludedFromVendorlist
    }
    this.classList?.map(value => {
      drops?.classList?.map(tl => {
        if (tl.id == value.id) {
          value.isActive = tl.isActive
        }
      })
    })
    this.vendorTypeList?.map(value => {
      drops?.vendorTypeList?.map(tl => {
        if (tl.id == value.id) {
          value.isActive = tl.isActive
        }
      })
    })
    if (checked?.activeList) {
      this.activeList = checked?.activeList
    }
    this.getAllDropDownModel?.altSalesPersonList?.map((gs) => {
      drops?.altSalesPersonList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.salesPersonList?.map((gs) => {
      drops?.salesPersonList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.buyerRepList?.map((gs) => {
      drops?.buyerRepList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.countryList?.map((gs) => {
      drops?.countryList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });

    this.getAllDropDownModel?.leadScoreList?.map((gd) => {
      drops?.leadScoreList?.map((value) => {
        if (gd.id == value.id) {
          gd.isActive = value.isActive
        }
      })
    })
    this.getAllDropDownModel?.stateList?.map((gs) => {
      drops?.stateList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.industryList?.map((gs) => {
      drops?.industryList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });

    this.getAllDropDownModel?.manufacturerList?.map((gs) => {
      drops?.manufacturerList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });

    this.getAllDropDownModel?.prospectScoreList?.map(gd => {
      drops?.prospectScoreList?.map(value => {
        if (gd.id == value.id) {
          gd.isActive = value.isActive
        }
      })
    })
    this.getAllDropDownModel?.stageStatusList?.map((gs) => {
      drops?.stageStatusList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.scopeList?.map((gs) => {
      drops?.scopeList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.timeZoneList?.map((gs) => {
      drops?.timeZoneList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.sicCodeList?.map((gs) => {
      drops?.sicCodeList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.naicsCodeList?.map((gs) => {
      drops?.naicsCodeList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.salesPersonList?.map((gs) => {
      drops?.salesPersonList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.partStatusList?.map((gs) => {
      drops?.partStatusList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.customerCompanyNameList?.map((gs) => {
      drops?.customerCompanyNameList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.contactNameList?.map((gs) => {
      drops?.contactNameList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.vendorNameList?.map((gs) => {
      drops?.vendorNameList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });
    this.getAllDropDownModel?.vendorContactList?.map((gs) => {
      drops?.vendorContactList?.map((value) => {
        if (gs.id == value.id) {
          gs.isActive = value.isActive;
        }
      });
    });

    // part library filters
    this.partTagsList?.map(value => {
      drops?.partTagsList?.map(tl => {
        if (tl.id == value.id) {
          value.isActive = tl.isActive
        }
      })
    })

    // ********* Requirement Filter *******

    this.requirementStatusList?.map(value => {
      drops?.requirementStatusList?.map((gs:any)=> {
        if(gs.id == value.id){
          value.isActive = gs?.isActive
        }
      })
    })
    this.opportunityTypeList?.map(value => {
      drops?.opportunityTypeList?.map((gs:any)=> {
        if(gs.id == value.id){
          value.isActive = gs?.isActive
        }
      })
    })
    
    this.opportunityBuyTypeList?.map(value => {
      drops?.opportunityBuyTypeList?.map((gs:any)=> {
        if(gs.id == value.id){
          value.isActive = gs?.isActive
        }
      })
    })

    this.priorityList?.map(value => {
      drops?.priorityList?.map((gs:any)=> {
        if(gs.id == value.id){
          value.isActive = gs?.isActive
        }
      })
    })


    this.data.categoryGroupId =  checked?.companyFilterList?.categoryGroupList;
    this.data.parentCategoryGroupId =  checked?.companyFilterList?.parentCategoryGroupList;
    this.data.inventoryCategoryId =  checked?.companyFilterList?.inventoryCategoryList;
    this.data.subCategoryId =  checked?.companyFilterList?.subCategoryList;

    this.getById(Categories?.CATEGORY_GROUPID,this.data.categoryGroupId,this.enumFilterLabel?.CATEGORY_GROUP)
    this.getById(Categories?.PARENT_CATEGORY_GROUPID,this.data.parentCategoryGroupId,this.enumFilterLabel?.PARENT_CATEGORY)
    this.getById(Categories?.CATEGORY_ID,this.data.inventoryCategoryId,this.enumFilterLabel?.CATEGORY)

    // extracting the names of  slected filters from local storage
    this.filterCheckList.salesPerson_CheckList = drops?.salesPersonList?.map(
      (value) => value.name
    );
    this.filterCheckList.alt_SalesPerson_CheckList =
      drops?.altSalesPersonList?.map((value) => value.name);
      
    this.filterCheckList.buyers_Rep_CheckList = drops?.buyerRepList?.map(
      (value) => value.name
    );
    this.filterCheckList.scope_CheckList = drops?.scopeList?.map(
      (value) => value.name
    );
    this.filterCheckList.leadScoreList_CheckList = drops?.leadScoreList?.map((value) => value.name)
    this.filterCheckList.state_CheckList = drops?.stateList?.map(
      (value) => value.name
    );
    this.filterCheckList.country_CheckList = drops?.countryList?.map(
      (value) => value.name
    );
    this.filterCheckList.sicCodeList_CheckList =
      drops?.sicCodeList?.map((value) => value.name);
    this.filterCheckList.intendToBuyList_CheckList =
      drops?.intendToBuyList?.map((value) => value.name);
    this.filterCheckList.industryList_CheckList =
      drops?.industryList?.map((value) => value.name);
    
    this.filterCheckList.manufacturerList_CheckList =
    drops?.manufacturerList?.map((value) => value.name);
      
    this.filterCheckList.leadsList_CheckList = drops?.leadsList?.map(
      (value) => value.name
    );
    this.filterCheckList.naicsCodeList_CheckList =
      drops?.naicsCodeList?.map((value) => value.name);
    this.filterCheckList.prospectScoreList_CheckList =
      drops?.prospectScoreList?.map((value) => value.name)
    this.filterCheckList.stageStatusList_CheckList =
      drops?.stageStatusList?.map((value) => value.name);
    this.filterCheckList.time_Zone_CheckList = drops?.timeZoneList?.map(
      (value) => value.name
    );

    // part library filters

    this.filterCheckList.partTagsList_CheckList = drops?.partTagsList?.map(
      (value) => value.name
    );

    this.filterCheckList.categoryGroupList_CheckList = drops?.categoryGroupList?.map(
      (value) => value.name
    );

    this.filterCheckList.parentCategoryGroupList_CheckList = drops?.parentCategoryGroupList?.map(
      (value) => value.name
    );

    this.filterCheckList.categoryList_CheckList = drops?.inventoryCategoryList?.map(
      (value) => value.name
    );

    this.filterCheckList.subCategoryList_CheckList = drops?.subCategoryList?.map(
      (value) => value.name
    );

    this.filterCheckList.partStatusList_CheckList = drops?.partStatusList?.map(
      (value) => value.name
    );
    this.filterCheckList.company_CheckList = drops?.customerCompanyNameList?.map(
      (value) => value.name
    );
    this.filterCheckList.companyContact_CheckList = drops?.contactNameList?.map(
      (value) => value.name
    );
    this.filterCheckList.vendor_CheckList = drops?.vendorNameList?.map(
      (value) => value.name
    );
    this.filterCheckList.vendorContact_CheckList = drops?.vendorContactList?.map(
      (value) => value.name
    );
  }

  clearStatusBar() {
    this.getAllDropDownModel.startRating = 0;
    this.getAllDropDownModel.endRating = 0;
  }

  clearSelectedItems(data) {
    switch (data) {
      case this.filterPopupVM.class:
        this.getAllDropDownModel?.classList?.map((a) => (a.isActive = false));
        this.getAllDropDownModel?.vendorTypeList?.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.active:
        this.activeList?.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.tags:
        this.getAllDropDownModel?.tagsList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.type:
        this.getAllDropDownModel?.typeList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.PartInventoryTags:
        this.getAllDropDownModel?.partTagsList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.Status:
        this.getAllDropDownModel?.requirementStatusList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.OpportunityType:
        this.getAllDropDownModel?.opportunityTypeList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.priorityType:
        this.getAllDropDownModel?.priorityList.map((a) => (a.isActive = false));
        break;
      case this.filterPopupVM.opportunityBuyType:
        this.getAllDropDownModel?.opportunityBuyTypeList.map((a) => (a.isActive = false));
        break;
    }
  }

  filterStatus(item) {
    this.activeList.map((a) => {
      if (a === item) {
        a.isActive = true;
      } else {
        a.isActive = false;
      }
    });
  }

  clearStausBar(){
    this.getAllDropDownModel.startRating = 0;
    this.getAllDropDownModel.endRating = 0;
  }

  clearAllFilter() {
    this.crmService.isActive.next(false);
    this.crmService.isRating.next(false)
    this.crmService.isSelected.next(false);
    this.getAllDropDownModel.startRating = 0;
    this.getAllDropDownModel.endRating = 0;
    this.getAllDropDownModel.archived = false;
    this.getAllDropDownModel.avl = false;
    this.getAllDropDownModel.navl = false;
    this.getAllDropDownModel.excludedFromVendorlist = false;
    this.getAllDropDownModel?.classList.map((a) => (a.isActive = false));
    this.getAllDropDownModel?.vendorTypeList.map((a) => (a.isActive = false));
    this.getAllDropDownModel?.tagsList.map((a) => (a.isActive = false));
    this.getAllDropDownModel?.partTagsList.map((a) => (a.isActive = false));
    this.activeList?.map((a) => (a.isActive = false));
    this.getAllDropDownModel.altSalesPersonList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.buyerRepList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.prospectScoreList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.leadScoreList.map(value => {
      value.isActive = false
    })
    this.getAllDropDownModel.countryList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.industryList.map(
      (value) => (value.isActive = false)
    );
   
    this.getAllDropDownModel.manufacturerList.map(
      (value) => (value.isActive = false)
    );

    this.getAllDropDownModel.intendToBuyList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.salesPersonList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.stateList.map((value) => (value.isActive = false));
    this.getAllDropDownModel.stageStatusList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.timeZoneList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.sicCodeList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel.naicsCodeList.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel?.partStatusList?.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel?.customerCompanyNameList?.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel?.contactNameList?.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel?.vendorNameList?.map(
      (value) => (value.isActive = false)
    );
    this.getAllDropDownModel?.vendorContactList?.map(
      (value) => (value.isActive = false)
    );

    this.getAllDropDownModel?.priorityList?.map(
      (value) => (value.isActive = false)
    );

    this.getAllDropDownModel?.opportunityBuyTypeList?.map(
      (value) => (value.isActive = false)
    );

    this.getAllDropDownModel?.opportunityTypeList?.map(
      (value) => (value.isActive = false)
    );

    this.getAllDropDownModel?.requirementStatusList?.map(
      (value) => (value.isActive = false)
    );

    this.data.categoryGroupId = this.data.parentCategoryGroupId  = this.data.inventoryCategoryId  = this.data.subCategoryId  = ''

    this.filterCheckList.leadScoreList_CheckList = []
    this.filterCheckList.alt_SalesPerson_CheckList = []
    this.filterCheckList.buyers_Rep_CheckList = []
    this.filterCheckList.country_CheckList = []
    this.filterCheckList.industryList_CheckList = []
    this.filterCheckList.intendToBuyList_CheckList = []
    this.filterCheckList.last_Contacted_CheckList = []
  // this.filterCheckList.last_Contacted_CheckList = ''
    this.filterCheckList.leadsList_CheckList = []
    this.filterCheckList.manufacturerList_CheckList = []
    this.filterCheckList.naicsCodeList_CheckList = []
    this.filterCheckList.salesPerson_CheckList = []
    this.filterCheckList.scope_CheckList = []
    this.filterCheckList.sicCodeList_CheckList = []
    this.filterCheckList.stageStatusList_CheckList = []
    this.filterCheckList.state_CheckList = []
    this.filterCheckList.time_Zone_CheckList = []
    this.filterCheckList.prospectScoreList_CheckList = []
    this.filterCheckList.partStatusList_CheckList = []
    this.filterCheckList.company_CheckList = []
    this.filterCheckList.companyContact_CheckList = []
    this.filterCheckList.vendor_CheckList = []
    this.filterCheckList.vendorContact_CheckList = []
  

    this.getAllDropDownModel.scopeList.map((value) => (value.isActive = false));
    this.contactedDate = '';
    this.filterCheckList.last_Contacted_CheckList = [];
    this.getAllDropDownModel.fromDate = '';
    this.dateRangeSelection = '';
    this.filterCheckList.date_range_CheckList = [];
    this.getAllDropDownModel.toDate = '';

  }

  applyChanges() {
    this.agGridService.toggleHeaderExpandIcon.next(false)
    this.getAllDropDownModel.endRating = this.getAllDropDownModel?.endRating?.toString() === "NaN"? 0 : this.getAllDropDownModel?.endRating;
    this.getAllDropDownModel.startRating = this.getAllDropDownModel?.startRating?.toString() === "NaN" ? 0  : this.getAllDropDownModel?.startRating;
    this.getAllDropDownModel.companyStatusId =
      this.activeList?.filter((a) => a?.isActive === true)[0]?.id ?? 2;
    this.getAllDropDownModel.salesPersonList =
      this.getAllDropDownModel?.salesPersonList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.altSalesPersonList =
      this.getAllDropDownModel?.altSalesPersonList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
      if(this.contactedDate){
        this.getAllDropDownModel.fromDate =  this.stringToDateService.dateConvertedToString(this.contactedDate);
        this.filterCheckList.last_Contacted_CheckList = this.contactedDate;
      }else if(this.contactedDate == ''){
        this.getAllDropDownModel.fromDate =  '';
        this.filterCheckList.last_Contacted_CheckList = [];

      }
      // if(this.contactedDate){
      //   this.getAllDropDownModel.fromDate =  this.stringToDateService.dateConvertedToString(this.contactedDate);
      //   this.filterCheckList.last_Contacted_CheckList = this.contactedDate;
      // }else if(this.contactedDate == ''){
      //   this.getAllDropDownModel.fromDate =  '';
      //   this.filterCheckList.last_Contacted_CheckList = [];

      // }
      if(this.dateRangeSelection){
        const [fromDateStr, toDateStr] = this.dateRangeSelection.split(' - ');
        this.getAllDropDownModel.fromDate = fromDateStr;
         this.getAllDropDownModel.toDate = toDateStr;
        this.filterCheckList.date_range_CheckList = this.dateRangeSelection;
      }else if(this.dateRangeSelection == ''){
        this.getAllDropDownModel.fromDate =  '';
        this.getAllDropDownModel.toDate = '';
        this.filterCheckList.date_range_CheckList = [];
      }
    this.getAllDropDownModel.buyerRepList =
      this.getAllDropDownModel?.buyerRepList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.classList =
      this.classList?.filter((a) => a?.isActive === true) ?? [];
    this.getAllDropDownModel.vendorTypeList =
      this.vendorTypeList?.filter((a) => a?.isActive === true) ?? [];
    this.getAllDropDownModel.countryList =
      this.getAllDropDownModel?.countryList?.filter(
        (a) => a?.isActive === true
      ) ?? [];

      this.getAllDropDownModel.tagsList =
      this.tagsList?.filter((a) => a?.isActive === true) ?? [];

    // part library filters

    this.getAllDropDownModel.partTagsList =
      this.partTagsList?.filter((a) => a?.isActive === true) ?? [];
    

    this.getAllDropDownModel.typeList =
      this.getAllDropDownModel?.typeList?.filter((a) => a?.isActive === true) ??
      [];
    this.getAllDropDownModel.timeZoneList =
      this.getAllDropDownModel?.timeZoneList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.stateList =
      this.getAllDropDownModel?.stateList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.scopeList =
      this.getAllDropDownModel?.scopeList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.prospectScoreList =
      this.getAllDropDownModel?.prospectScoreList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.industryList =
    this.getAllDropDownModel?.industryList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    
    this.getAllDropDownModel.manufacturerList =
    this.getAllDropDownModel?.manufacturerList?.filter(
        (a) => a?.isActive === true
      ) ?? [];  

    this.getAllDropDownModel.intendToBuyList =
      this.getAllDropDownModel?.intendToBuyList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.naicsCodeList =
      this.getAllDropDownModel?.naicsCodeList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.sicCodeList =
      this.getAllDropDownModel?.sicCodeList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.leadsList =
      this.getAllDropDownModel?.leadsList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
    this.getAllDropDownModel.stageStatusList =
      this.getAllDropDownModel?.stageStatusList?.filter(
        (a) => a?.isActive === true
      ) ?? [];
  
      // part library filters

    this.getAllDropDownModel.categoryGroupList =
    this.getAllDropDownModel?.categoryGroupList?.filter(
        (a) => a?.id === this.data?.categoryGroupId
      ) ?? [];

    this.getAllDropDownModel.parentCategoryGroupList =
    this.getAllDropDownModel?.parentCategoryGroupList?.filter(
        (a) => a?.id === this.data?.parentCategoryGroupId
    ) ?? [];

    this.getAllDropDownModel.inventoryCategoryList =
    this.getAllDropDownModel?.inventoryCategoryList?.filter(    
      (a) => a?.id === this.data?.inventoryCategoryId
    ) ?? [];

    this.getAllDropDownModel.subCategoryList = 
    this.getAllDropDownModel?.subCategoryList?.filter(    
      (a) => a?.id === this.data?.subCategoryId
    ) ?? [];

    this.getAllDropDownModel.partStatusList =
    this.getAllDropDownModel?.partStatusList?.filter(
      (a) => a?.isActive === true
    ) ?? [];
  
    this.getAllDropDownModel.customerCompanyNameList =
    this.getAllDropDownModel?.customerCompanyNameList?.filter(
      (a) => a?.isActive === true
    ) ?? [];

    this.getAllDropDownModel.contactNameList =
    this.getAllDropDownModel?.contactNameList?.filter(
      (a) => a?.isActive === true
    ) ?? [];

    this.getAllDropDownModel.vendorNameList =
    this.getAllDropDownModel?.vendorNameList?.filter(
      (a) => a?.isActive === true
    ) ?? [];

    this.getAllDropDownModel.vendorContactList =
    this.getAllDropDownModel?.vendorContactList?.filter(
      (a) => a?.isActive === true
    ) ?? [];


    // ***** Requirement Filters ******

    this.getAllDropDownModel.requirementStatusList =
    this.getAllDropDownModel?.requirementStatusList.filter(
      (a) => a?.isActive === true) ?? [];

    this.getAllDropDownModel.opportunityTypeList = 
    this.getAllDropDownModel?.opportunityTypeList.filter(
      (a) => a?.isActive === true) ?? [];

    this.getAllDropDownModel.priorityList = 
    this.getAllDropDownModel?.priorityList.filter(
      (a) => a?.isActive === true) ?? [];

    this.getAllDropDownModel.opportunityBuyTypeList = 
    this.getAllDropDownModel?.opportunityBuyTypeList.filter(
      (a) => a?.isActive === true) ?? [];

    this.getAllDropDownModel.leadScoreList = this.getAllDropDownModel?.leadScoreList?.filter(a => a?.isActive == true)
    this.getAllDropDownModel.filterTypeId = this.currentTab == this.enumTabNames.VENDOR_CONTACT || this.currentTab == this.enumTabNames.VENDOR_LIST ? 2 : 1
    this.creatingFilterList()

    //--------------- Start ------------------------------------- 
    // this will create companyFilterResponse
    // the data of this array will get show on header
    let newData:any = [];
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      if (this.getAllDropDownModel.endRating) {
        newData.push({
          id: '1',
          labelName: 'Close Probability',
          colorCode: 'string',

          name:
            this.getAllDropDownModel?.startRating + ' to ' +
            this.getAllDropDownModel?.endRating,
          isActive: this.getAllDropDownModel?.endRating > 0 ? false : true,
        },)
      }
    } else {
      if (this.getAllDropDownModel.endRating) {
        newData.push({
          id: '1',
          labelName: 'rating',
          colorCode: 'string',

          name:
            this.getAllDropDownModel?.startRating + ' to ' +
            this.getAllDropDownModel?.endRating + ' stars',
          isActive: this.getAllDropDownModel?.endRating > 0 ? false : true,
        },)
      }
    }
    if (this.getAllDropDownModel.archived) {
      newData.push({
        id: '101',
        labelName: 'archived',
        colorCode: 'string',

        name: "Archived",
        isActive: this.getAllDropDownModel.archived,
      },)
    }
    
    if (this.getAllDropDownModel.excludedFromVendorlist) {
      newData.push({
        id: '102',
        labelName: 'excludedFromVendorlist',
        colorCode: 'string',
       // name: "Excluded From Vendor List",
       name:this.route == this.routerPath.COMPANY_ROUTEPATH ?"Include Excluded" : "Excluded From Vendor List",
        isActive: this.getAllDropDownModel.excludedFromVendorlist,
      },)
    }
    if (this.getAllDropDownModel.avl) {
      newData.push({
        id: '103',
        labelName: 'AVL',
        colorCode: 'string',
        name: "AVL",
        isActive: true,
      },)
    }
    if (this.getAllDropDownModel.navl) {
      newData.push({
        id: '104',
        labelName: 'NAVL',
        colorCode: 'string',
        name: "NAVL",
        isActive: true,
      },)
    }
    // if (this.getAllDropDownModel.fromDate) {
    //   newData.push({id:'',
    //   labelName: 'Contacted Date',
    //   name:this.getAllDropDownModel?.fromDate})
    // }

if (this.currentTab == this.enumTabNames.PARTLIST) {
      if (this.getAllDropDownModel.fromDate && this.getAllDropDownModel.toDate) {
      newData.push({id:'',
      labelName: 'DateRange',
      name:this.dateRangeSelection})
    }
 }else if(this.currentTab == this.enumTabNames.REQUIREMENTS){
    if(this.getAllDropDownModel.fromDate && this.getAllDropDownModel.toDate){
      newData.push({id:'',
        labelName: "Requirement Date",
        name:this.dateRangeSelection
      })
    }
 }
 else{
    if (this.getAllDropDownModel.fromDate) {
      newData.push({id:'',
      labelName: 'Contacted Date',
      name:this.getAllDropDownModel?.fromDate})
    }
 }

    newData.push(
    //  ...this.getAllDropDownModel?.lastContactedDate,
      ...this.classList?.filter((a) => a?.isActive === true),
      ...this.vendorTypeList?.filter((a) => a?.isActive === true),
      ...this.getAllDropDownModel?.buyerRepList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.leadScoreList?.filter(a => a?.isActive == true),
      ...this.getAllDropDownModel?.altSalesPersonList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.salesPersonList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.stateList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel.prospectScoreList?.filter(a => a?.isActive === true),
      ...this.getAllDropDownModel?.industryList?.filter(
        (a) => a?.isActive === true
      ),

     // ...this.getAllDropDownModel?.prospectScoreList?.filter(a => a?.isActive === true),
      ...this.getAllDropDownModel?.manufacturerList?.filter(
        (a) => a?.isActive === true
      ),

      ...this.getAllDropDownModel?.intendToBuyList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.countryList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.tagsList?.filter((a) => a?.isActive === true),
      ...this.getAllDropDownModel?.scopeList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.timeZoneList?.filter(a => a?.isActive == true),
      ...this.getAllDropDownModel?.typeList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.naicsCodeList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.stageStatusList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.leadsList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.sicCodeList?.filter(
        (a) => a?.isActive === true
      ),
     
      // Part Library Filters

     ...this.getAllDropDownModel?.partTagsList?.filter(
        (a) => a?.isActive === true
      ), 

      ...this.getAllDropDownModel?.categoryGroupList?.filter(
        (a) => a?.id === this.data?.categoryGroupId
      ),
      
      ...this.getAllDropDownModel?.parentCategoryGroupList?.filter(
        (a) => a?.id === this.data?.parentCategoryGroupId
      ),

      ...this.getAllDropDownModel?.inventoryCategoryList?.filter(
        (a) => a?.id === this.data?.inventoryCategoryId
      ),

      ...this.getAllDropDownModel?.subCategoryList?.filter(
        (a) => a?.id === this.data?.subCategoryId
      ),
      ...this.getAllDropDownModel?.partStatusList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.customerCompanyNameList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.contactNameList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.vendorNameList?.filter(
        (a) => a?.isActive === true
      ),
      ...this.getAllDropDownModel?.vendorContactList?.filter(
        (a) => a?.isActive === true
      ),

      // Requirement Filter 
      
      ...this.getAllDropDownModel?.opportunityBuyTypeList.filter(
        (a)=> a?.isActive === true
      ),
      ...this.getAllDropDownModel?.requirementStatusList.filter(
        (a)=> a?.isActive === true
      ),
      ...this.getAllDropDownModel?.opportunityTypeList.filter(
        (a)=> a?.isActive === true
      ),
      ...this.getAllDropDownModel?.priorityList.filter(
        (a)=> a?.isActive === true
      ),

      ...this.activeList.filter((a) => a?.isActive === true)
    );
    //--------------- End ------------------------------------- 
    if (this.currentTab == this.enumTabNames.COMPANIES) {
      this.storage.store(this.enumTabNames.COMPANIES_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.LEADS ) {
      this.storage.store(this.enumTabNames.LEADS_FILTERS , {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.CUSTOMERS) {
      this.storage.store(this.enumTabNames.CUSTOMERS_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.PROSPECTS) {
      this.storage.store(this.enumTabNames.PROSPECTS_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.CONTACTS) {
      this.storage.store(this.enumTabNames.CONTACTS_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.VENDOR_LIST) {
      this.storage.store(this.enumTabNames.VENDORLIST_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.VENDOR_CONTACT) {
      this.storage.store(this.enumTabNames.VENDORCONTACT_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }

    if (this.currentTab == this.enumTabNames.PARTLIST) {
      this.storage.store(this.enumTabNames.PARTLIST_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.VENDOR_PART_LIBRAY) {
      this.storage.store(this.enumTabNames.VENDORPARTLIBRAY_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.OEM_EXCESS_MANAGER) {
      this.storage.store(this.enumTabNames.OEMEXCESSMANAGER_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    if (this.currentTab == this.enumTabNames.REQUIREMENTS) {
      this.storage.store(this.enumTabNames.REQUIREMENTS_FILTERS, {
        allDropDowns: this.getAllDropDownModel,
        companyFilterResponse: newData,
        companyFilterList: this.companyFiltersList,
        activeList: this.activeList
      });
    }
    // this.crmService
    //   .insertFilterRecord(this.getAllDropDownModel)
    //   .subscribe((res) => {
    //     if (res.isSuccess) {
    //     } else {
    //       this.toastr.info(res.message);
    //     }
    //   });
    if (this.getAllDropDownModel.companyStatusId != 2) {
      this.crmService.isActive.next(true);
    }
    if (this.getAllDropDownModel.endRating != 0) {
      this.crmService.isRating.next(true)
    }
    this.getDataFromStorage()
    this.toastr.success("Filter inserted successfully.");
    this.activeModal.close(true);
  }

  getDataFromStorage() {
    let grids = this.storage.retrieve("userSetting")
    // stored grids
    this.userSetting.companies = grids.companies;
    this.userSetting.contacts = grids.contacts;
    this.userSetting.customers = grids.customers;
    this.userSetting.leads = grids.leads;
    this.userSetting.prospects = grids.prospects;
    this.userSetting.vendorLists = grids.vendorList
    this.userSetting.vendorContacts = grids.vendorContact
    this.userSetting.pinnedValues = grids.pinnedValues;
    this.userSetting.partlist = grids.partlist;
    this.userSetting.vendorPartsLibrary = grids.vendorPartsLibrary;
    this.userSetting.oemExcessManager = grids.oemExcessManager;
    // stored filter
    this.userSetting.companiesFilter = this.storage.retrieve(this.enumTabNames.COMPANIES_FILTERS)
    this.userSetting.contactFilter = this.storage.retrieve(this.enumTabNames.CONTACTS_FILTERS)
    this.userSetting.customersFilters = this.storage.retrieve(this.enumTabNames.CUSTOMERS_FILTERS)
    this.userSetting.leadsFilter = this.storage.retrieve(this.enumTabNames.LEADS_FILTERS )
    this.userSetting.prospectsFilter = this.storage.retrieve(this.enumTabNames.PROSPECTS_FILTERS)
    this.userSetting.vendorListFilters = this.storage.retrieve(this.enumTabNames.VENDORLIST_FILTERS)
    this.userSetting.vendorContactsFilter = this.storage.retrieve(this.enumTabNames.VENDORCONTACT_FILTERS)
    this.userSetting.partlistFilter = this.storage.retrieve(this.enumTabNames.PARTLIST_FILTERS)
    this.userSetting.vendorPartLibraryFilter = this.storage.retrieve(this.enumTabNames.VENDORPARTLIBRAY_FILTERS)
    this.userSetting.oemExcessManagerFilter = this.storage.retrieve(this.enumTabNames.OEMEXCESSMANAGER_FILTERS)
    this.userSetting.requirementFilters = this.storage.retrieve(this.enumTabNames.REQUIREMENTS_FILTERS)
    this.saveUserSetting.userSetting = JSON.stringify(this.userSetting);
    this.agGridService.saveUserSetting(this.saveUserSetting).subscribe(res => {
      const json = JSON.parse(res?.response);
      this.storage.store("userSetting", json)
    })
  }

  creatingFilterList() {
    this.companyFiltersList.fromDate = this.getAllDropDownModel.fromDate;
     this.companyFiltersList.toDate = this.getAllDropDownModel.toDate;


    //--------------- Start ------------------------------------- 
    //  this will create companyFilterList
    // we will pass the result of this to api to filter that grid
     this.companyFiltersList.startRating = this.getAllDropDownModel.startRating;
     this.companyFiltersList.endRating = this.getAllDropDownModel.endRating;
    this.companyFiltersList.excludedFromVendorlist = this.getAllDropDownModel.excludedFromVendorlist
    if (this.activeList[0].isActive) {
      this.companyFiltersList.companyStatusId = 1;
    }
    if (this.activeList[1].isActive) {
      this.companyFiltersList.companyStatusId = 0;
    }
    if (this.activeList[0].isActive && this.activeList[1].isActive) {
      this.companyFiltersList.companyStatusId = 2;
    }


    let leadScoreListIds: any[] = this.getAllDropDownModel.leadScoreList.map((object) => object.id);
    this.companyFiltersList.leadScoreList = leadScoreListIds.join(',');
    let salesPersonListIds: any[] =
      this.getAllDropDownModel.salesPersonList.map((object) => object.id);
    this.companyFiltersList.salesPersonList = salesPersonListIds.join(",");

    let classListIds: any[] =
      this.getAllDropDownModel.classList.map((object) => object.id);
    this.companyFiltersList.classList = classListIds.join(",");

    let vendorTypeListIds: any[] =
      this.getAllDropDownModel.vendorTypeList.map((object) => object.id);
    this.companyFiltersList.vendorTypeList = vendorTypeListIds.join(",");


    this.companyFiltersList.archived = this.getAllDropDownModel.archived
    this.companyFiltersList.avlId = this.getAllDropDownModel.avlId
    let altSalesPersonListIds: any[] =
      this.getAllDropDownModel.altSalesPersonList.map((object) => object.id);
    this.companyFiltersList.altSalesPersonList =
      altSalesPersonListIds.join(",");

    let prospectListIds: any[] =
      this.getAllDropDownModel.prospectScoreList.map((object) => object.id);
    this.companyFiltersList.prospectScoreList =
      prospectListIds.join(",");

    let buyerRepListIds: any[] = this.getAllDropDownModel.buyerRepList.map(
      (object) => object.id
    );
    this.companyFiltersList.buyerRepList = buyerRepListIds.join(",");

    let countryListIds: any[] = this.getAllDropDownModel.countryList.map(
      (object) => object.id
    );
    this.companyFiltersList.countryList = countryListIds.join(",");

    let tagsListIds: any[] = this.getAllDropDownModel.tagsList.map(
      (object) => object.id
    );
    this.companyFiltersList.tagsList = tagsListIds.join(",");

    let typeListIds: any[] = this.getAllDropDownModel.typeList.map(
      (object) => object.id
    );

    let timezoneListIds: any[] = this.getAllDropDownModel.timeZoneList.map(
      (object) => object.id
    );
    this.companyFiltersList.timeZoneList = timezoneListIds.join(",");

    let stageListIds: any[] = this.getAllDropDownModel.stageStatusList.map(
      (object) => object.id
    );
    this.companyFiltersList.stageStatusList = stageListIds.join(",");

    let stateListIds: any[] = this.getAllDropDownModel.stateList.map(
      (object) => object.id
    );
    this.companyFiltersList.stateList = stateListIds.join(',')
    let scopeListIds: any[] = this.getAllDropDownModel.scopeList.map(
      (object) => object.id
    );
    this.companyFiltersList.scopeList = scopeListIds.join(",");

    let industryListIds: any[] = this.getAllDropDownModel.industryList.map(
      (object) => object.id
    );
    this.companyFiltersList.industryList = industryListIds.join(",");

    let manufacturerListIds: any[] = this.getAllDropDownModel.manufacturerList.map(
      (object) => object.id
    );
    this.companyFiltersList.manufacturerList = manufacturerListIds.join(",");

    let naicsCodeListIds: any[] = this.getAllDropDownModel.naicsCodeList.map(
      (object) => object.name
    );
    this.companyFiltersList.naicsCodeList = naicsCodeListIds.join(",");

    let sicCodeListIds: any[] = this.getAllDropDownModel.sicCodeList.map(
      (object) => object.name
    );
    this.companyFiltersList.sicCodeList = sicCodeListIds.join(",");

    //  part list filters

    let partTagsListIds: any[] = this.getAllDropDownModel.partTagsList.map(
      (object) => object.id
    );
    this.companyFiltersList.partTagsList = partTagsListIds.join(",");

    let categoryGroupListIds: any[] = this.getAllDropDownModel.categoryGroupList.map(
      (object) => object.id
    );
    this.companyFiltersList.categoryGroupList = categoryGroupListIds.join(",");

    let parentCategoryGroupListIds: any[] = this.getAllDropDownModel.parentCategoryGroupList.map(
      (object) => object.id
    );
    this.companyFiltersList.parentCategoryGroupList = parentCategoryGroupListIds.join(",");

    let inventoryCategoryListIds: any[] = this.getAllDropDownModel.inventoryCategoryList.map(
      (object) => object.id 
    );
    this.companyFiltersList.inventoryCategoryList = inventoryCategoryListIds.join(",");

    let subCategoryListIds: any[] = this.getAllDropDownModel.subCategoryList.map(
      (object) => object.id
    );
    this.companyFiltersList.subCategoryList = subCategoryListIds.join(",");

    let partStatusListIds: any[] = this.getAllDropDownModel?.partStatusList?.map(
      (object) => object.id
    );
    this.companyFiltersList.partStatusList = partStatusListIds?.join(",");
  
    let companyNameListIds: any[] = this.getAllDropDownModel?.customerCompanyNameList?.map(
      (object) => object.id
    );
    this.companyFiltersList.customerCompanyNameList = companyNameListIds?.join(",");

    let contactNameListIds: any[] = this.getAllDropDownModel?.contactNameList?.map(
      (object) => object.id
    );
    this.companyFiltersList.contactNameList = contactNameListIds?.join(",");

    let vendorNameListIds: any[] = this.getAllDropDownModel?.vendorNameList?.map(
      (object) => object.id
    );
    this.companyFiltersList.vendorNameList = vendorNameListIds?.join(",");

    let vendorContactListIds: any[] = this.getAllDropDownModel?.vendorContactList?.map(
      (object) => object.id
    );
    this.companyFiltersList.vendorContactList = vendorContactListIds?.join(",");

    //  Requirment Filters

    let requirementStatusIds: any[] = this.getAllDropDownModel.requirementStatusList.map(
      (object) => object.id
    );
    this.companyFiltersList.requirementStatusList = requirementStatusIds.join(",");

    let opportunityTypeIds: any[] = this.getAllDropDownModel.opportunityTypeList.map(
      (object) => object.id
    );
    this.companyFiltersList.opportunityTypeList = opportunityTypeIds.join(",");

    let opportunityBuyTypeIds: any[] = this.getAllDropDownModel.opportunityBuyTypeList.map(
      (object) => object.id
    );
    this.companyFiltersList.opportunityBuyTypeList = opportunityBuyTypeIds.join(",");

    let priorityTypeIds: any[] = this.getAllDropDownModel.priorityList.map(
      (object) => object.id
    );
    this.companyFiltersList.priorityList = priorityTypeIds.join(",");


    //--------------- End ------------------------------------- 
  }
  isCheckedInclude() {
    this.getAllDropDownModel.archived = !this.getAllDropDownModel.archived;
  }
  isCheckedExclude(event) {
    this.getAllDropDownModel.excludedFromVendorlist = event;
  }


  AVLId(event) {
    this.getAllDropDownModel.avl = !this.getAllDropDownModel.avl
    if (event) {
      this.getAllDropDownModel.avlId = 1
    }
    if (!event && this.getAllDropDownModel.navl) {
      this.getAllDropDownModel.avlId = 2
    }
    if (!event && !this.getAllDropDownModel.navl) {
      this.getAllDropDownModel.avlId = 0
    }
    if (event && this.getAllDropDownModel.navl) {
      this.getAllDropDownModel.avlId = 3
    }
  }
  NAVLId(event) {
    this.getAllDropDownModel.navl = !this.getAllDropDownModel.navl
    if (event) {
      this.getAllDropDownModel.avlId = 2
    }
    if (!event && this.getAllDropDownModel.avl) {
      this.getAllDropDownModel.avlId = 1
    }
    if (!event && !this.getAllDropDownModel.avl) {
      this.getAllDropDownModel.avlId = 0
    }
    if (event && this.getAllDropDownModel.avl) {
      this.getAllDropDownModel.avlId = 3
    }
  }

  onChangedValue(event: any, label: string) {
    if (event === '') {
      this.clearFields(label, event);
    }else if (event) {
      this.clearFields(label, '');
      this.fetchById(label, event);
    }
  }
  clearFields(label, value) {
    switch (label) {
      case this.enumFilterLabel?.CATEGORY_GROUP:
        this.data.parentCategoryGroupId = this.data.inventoryCategoryId = this.data.subCategoryId =  value;
        break;
      case this.enumFilterLabel?.PARENT_CATEGORY:
        this.data.inventoryCategoryId = this.data.subCategoryId = value;
        break;
      case this.enumFilterLabel?.CATEGORY:
        this.data.subCategoryId = value;
        break;
    }
  }
  
  fetchById(label, event) {
    const ids = {
      [this.enumFilterLabel?.CATEGORY_GROUP]: Categories?.CATEGORY_GROUPID,
      [this.enumFilterLabel?.PARENT_CATEGORY]: Categories?.PARENT_CATEGORY_GROUPID,
      [this.enumFilterLabel?.CATEGORY]: Categories?.CATEGORY_ID,
    };
    this.getById(ids[label], event, label);
  }
  
  getById(request,id,label) {
    this.partsListService.getInventoryCategoryDropdownById(request,id).subscribe((res) => {
      if (res) {
        switch (label) {
          case this.enumFilterLabel?.CATEGORY_GROUP:
            this.getAllDropDownModel.parentCategoryGroupList = res?.response?.list
            break
          case this.enumFilterLabel?.PARENT_CATEGORY:
            this.getAllDropDownModel.inventoryCategoryList = res?.response?.list
            break
          case this.enumFilterLabel?.CATEGORY:
            this.getAllDropDownModel.subCategoryList = res?.response?.list
            break
        }
      }
    })
  }

 onDateRangeChange(event:any) {
      this.dateRangeSelection = `${this.formatter.format(event.startDate)} - ${this.formatter.format(event.endDate)}`;
  }
  
}
